// About.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './LegalPages.css';
import logo from '../images/logo.png';

function About() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user'));
  const user_id = user?.user_id;

  const teamMembers = [
    {
      name: "Aman Rajput",
      role: "Founder & Lead Developer",
      bio: "Full-stack developer passionate about AI and creating innovative solutions.",
      icon: "bi-person-circle"
    },
    {
      name: "AI Research Team",
      role: "Machine Learning Experts",
      bio: "Dedicated team working on improving AI models and response quality.",
      icon: "bi-robot"
    },
    {
      name: "Design Team",
      role: "UX/UI Designers",
      bio: "Creating intuitive and beautiful user experiences.",
      icon: "bi-palette"
    }
  ];

  const milestones = [
    { year: "2025", title: "Project Started (Jan 2025)", description: "Marshall AI concept and initial development" },
    { year: "2025", title: "Beta Launch (Nov 2025)", description: "First beta version released to early users" },
    { year: "2026", title: "Public Release (April 2026)", description: "Full public launch with advanced features" }
  ];

  return (
    <div className="legal-page light-theme">
      {/* Navigation */}
      <nav className="legal-navbar">
        <div className="legal-nav-container">
          <button
            className="legal-brand"
            onClick={() => navigate(user_id ? '/home' : '/')}
          >
            <img src={logo} alt='Marshall AI Logo' className='legal-logo' />
            <span>Marshall AI</span>
          </button>
          <button
            className="legal-back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Back
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <div className="legal-container">
        <div className="legal-content">
          <h1 className="legal-title">About Us</h1>
          <p className="legal-last-updated">Building the Future of AI Conversations</p>

          {/* Mission Section */}
          <section className="legal-section">
            <h2>Our Mission</h2>
            <p>
              At Marshall AI, we're on a mission to make artificial intelligence accessible, 
              helpful, and secure for everyone. We believe that AI should enhance human creativity 
              and productivity, not replace it.
            </p>
            <p>
              Our AI assistant is designed to understand context, provide accurate information, 
              and assist with a wide range of tasks - from coding and writing to image analysis 
              and creative brainstorming.
            </p>
          </section>

          {/* Story Section */}
          <section className="legal-section">
            <h2>Our Story</h2>
            <p>
              Marshall AI was born from a simple idea: create an AI assistant that truly understands 
              and helps people. What started as a personal project in 2024 has grown into a 
              full-featured AI platform used by thousands of users worldwide.
            </p>
            <p>
              Named after the legendary amplifier that revolutionized music, Marshall AI aims to 
              amplify human potential through intelligent conversation and assistance.
            </p>
          </section>

          {/* Values Section */}
          <section className="legal-section">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <i className="bi bi-shield-check value-icon"></i>
                <h3>Privacy First</h3>
                <p>Your data is yours. We encrypt everything and never sell your information.</p>
              </div>
              <div className="value-card">
                <i className="bi bi-lightbulb value-icon"></i>
                <h3>Innovation</h3>
                <p>Constantly improving our AI to provide better, faster, and more accurate responses.</p>
              </div>
              <div className="value-card">
                <i className="bi bi-people value-icon"></i>
                <h3>User Centric</h3>
                <p>Every feature is designed with our users' needs and feedback in mind.</p>
              </div>
              <div className="value-card">
                <i className="bi bi-globe value-icon"></i>
                <h3>Accessibility</h3>
                <p>Making AI available to everyone, regardless of technical expertise.</p>
              </div>
            </div>
          </section>

          {/* Timeline Section */}
          <section className="legal-section">
            <h2>Our Journey</h2>
            <div className="timeline">
              {milestones.map((milestone, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-year">{milestone.year}</div>
                  <div className="timeline-content">
                    <h3>{milestone.title}</h3>
                    <p>{milestone.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Team Section */}
          <section className="legal-section">
            <h2>Meet the Team</h2>
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div key={index} className="team-card">
                  <i className={`bi ${member.icon} team-avatar`}></i>
                  <h3>{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="team-bio">{member.bio}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Stats Section */}
          {/* <section className="legal-section">
            <h2>By the Numbers</h2>
            <div className="stats-grid">
              <div className="stat-card">
                <h3>10K+</h3>
                <p>Active Users</p>
              </div>
              <div className="stat-card">
                <h3>1M+</h3>
                <p>Conversations</p>
              </div>
              <div className="stat-card">
                <h3>99.9%</h3>
                <p>Uptime</p>
              </div>
              <div className="stat-card">
                <h3>24/7</h3>
                <p>Availability</p>
              </div>
            </div>
          </section> */}

          {/* Contact CTA */}
          <section className="legal-section">
            <h2>Get in Touch</h2>
            <p>
              Have questions, feedback, or want to collaborate? We'd love to hear from you!
            </p>
            <button
              className="btn btn-outline-dark"
              onClick={() => navigate('/contact')}
              style={{ marginTop: '1rem' }}
            >
              <i className="bi bi-envelope me-2"></i>
              Contact Us
            </button>
          </section>
        </div>
      </div>
    </div>
  );
}

export default About;